// import {number} from "prop-types";

import {useTranslation} from "react-i18next";
import i18n from "i18next";
import CanvasJSReact from "../canvasjs-3.7/canvasjs.react";


import * as constants from './const.js';
import {string} from "prop-types";


const CanvasJS = CanvasJSReact.CanvasJS;


const SumValues = obj => Object.values(obj).reduce((a, b) => a + b, 0);


function get_elements(string_array, type) {
    let answer = "";
    string_array = (string_array + '').split(',')
    for (const el in string_array) {
        let name_el = string_array[el]
        if (type !== 'age') {
            name_el = i18n.t(`${type}_${string_array[el]}`)
        }
        answer = answer.concat(',', `${name_el}`)
    }
    return answer.slice(1)
}

function my_stringify(json) {
    let array = "";
    for (const el in json) {
        const name_el = i18n.t(`filter_${el}`)
        array = array.concat('', `${name_el}: `);
        array = array.concat('', `${get_elements(json[el], el)}\n`);
    }
    return array;
}


function counter_to_canvas_json(counter, color, name_prefix = "") {
    const pie_json = [];
    let n = SumValues(counter);
    let col_iterator = 0;
    for (const el in counter) {
        let col = color;
        if (col === null) {
            col = constants.COLORS[col_iterator]
            col_iterator += 1
        }
        pie_json.push({
            y: counter[el],
            label: i18n.t(`${name_prefix}${el}`),
            color: col,
            percentage: (counter[el] / n * 100).toFixed(2)
        })
    }
    return pie_json;
}


const make_pie_from_json_dict = function (json, header, name_prefix = "") {
    const pie_json = counter_to_canvas_json(json, null, name_prefix);
    return {
        animationEnabled: true,
        exportEnabled: true,
        theme: "light2",
        title: {
            text: header
        },
        data: [{
            type: "pie",
            indexLabel: "{label}: {percentage}% ({y})",
            startAngle: -90,
            dataPoints: pie_json
        }]
    }
}


const make_hist_from_json_dict = function (json, header, name_prefix = "") {
    const pie_json = counter_to_canvas_json(json, "#94c6da", name_prefix);
    return {
        animationEnabled: true,
        exportEnabled: true,
        theme: "light2",
        title: {
            text: header,
        },
        data: [
            {
                // Change type to "doughnut", "line", "splineArea", etc.
                type: "column",
                dataPoints: pie_json
            }
        ]
    }

}


const jsonToTable = function (jsonData) {
    const columns = Object.keys(jsonData);

    // Extract all the keys from the first column to create column headers
    const allKeys = Object.keys(jsonData[columns[0]]);

    const tableData = allKeys.map((key) => {
        const rowData = columns.map((column) => {
            let value = jsonData[column][key];

            // Check if the value is a link (assuming links start with 'http' or 'https')
            if (/^https?:\/\//.test(value)) {
                return (
                    <td key={column}>
                        <a href={value} target="_blank" rel="noopener noreferrer">{i18n.t("link_word")}</a>
                    </td>
                );
            } else {
                return (
                    <td key={column}>{i18n.t(value)}</td>
                );
            }
        });

        return (
            <tr key={key}>
                {rowData}
            </tr>
        );
    });

    const tableHeaders = columns.map((column) => (
        <th key={column}>{i18n.t(`header_${column}`)}</th>
    ));


    if (tableData.length > 0) {
        return (
            <div className="table-responsive">
                <table className="table table-bordered table-striped">
                    <thead>
                    <tr>
                        {tableHeaders}
                    </tr>
                    </thead>
                    <tbody>
                    {tableData}
                    </tbody>
                </table>
            </div>
        );
    }else{
        return <div>{i18n.t('not_found')}<br/></div>
    }
};


const jsonToList = function (jsonData) {
    if (jsonData.length > 0){
        return (
            <ul>
                {jsonData.map((item, index) => (
                    <li key={index}>
                        <a href={item[0]} target="_blank" rel="noopener noreferrer">
                            {i18n.t(item[1])}
                        </a>
                    </li>
                ))}
            </ul>
        );
    }else{
        return <div>{i18n.t('not_found')}<br/></div>
    }
}


// eslint-disable-next-line import/no-anonymous-default-export
export default {
    make_hist_from_json_dict,
    make_pie_from_json_dict,
    my_stringify,
    jsonToTable,
    jsonToList,
};
